import type { BroadcastingService } from "../types";

export class NoopService implements BroadcastingService {
  listenEvents() {
    return Promise.resolve();
  }

  unlistenEvents() {}
}
